import './Fee.scss';

import React from 'react';

import Price from '@/common/components/blocks/Price/Price';

import { FeeDefaultProps, FeePropTypes } from './Fee.proptypes';

const Fee = ({ label, price }) => (
  <div className="order-item-fee">
    <div className="order-item-fee__label">{label}</div>
    <div className="order-item-fee__price">
      <Price value={price} />
    </div>
  </div>
);

Fee.defaultProps = {
  ...FeeDefaultProps,
};

Fee.propTypes = {
  ...FeePropTypes,
};

export default Fee;
